<div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="0px" fxLayoutGap.lt-md="20px"
    fxLayoutAlign="space-between center">

    <mat-card *ngFor="let tipoLider of tipoLiders; let x = index;" class="card" (click)="iChoseThisTest(tipoLider.id)">
        <img class="feather-check-circle"
            src="assets\img\leadership\how-to-take-leadership-test\icon-feather-check-circle.svg" alt="">
        <img *ngIf="tipoLider.imagem" [src]="storageUrl + tipoLider.imagem" alt="">
        <div fxLayout="row" fxLayoutAlign="end">
            <span *ngIf="tipoLider.respondidoEm">Respondido em: {{tipoLider.respondidoEm}}</span>
        </div>
        <mat-card-content class="description-img-box">
            <p>
                {{ tipoLider.descricao }}
            </p>
        </mat-card-content>
    </mat-card>
</div>